// app/silent-redirect/silent-redirect.component.ts
import { Component, OnInit } from '@angular/core';
import { msalInstance } from '../app.config';
import { Router } from '@angular/router';

@Component({
    selector: 'app-silent-redirect',
    templateUrl: 'silent-redirect.component.html',
    standalone: true
})
export class SilentRedirectComponent implements OnInit {

    constructor(private router: Router) {

    }

    async ngOnInit() {

        if (window.location.hash.length > 1) {
            await msalInstance.handleRedirectPromise();
        } else {
            this.router.navigate(['/business-reg']);
        }
    }
}